module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-beijing.525077e9.png";